/* src/app/features/contratacao/devolucao/detalhe/devolucao-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=devolucao-detalhe.component.css.map */
